import { render, staticRenderFns } from "./socialIcons.vue?vue&type=template&id=54dfd4e6"
import script from "./socialIcons.vue?vue&type=script&lang=js"
export * from "./socialIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports